import { METRIC_AGGREGATES } from '@vision360/contracts';
import { z } from 'zod';
import { TIME_RANGES } from './hooks';

/** Props shared by widgets that bind to a metric (TechSpec §9.2 rule 3). */
export const metricBinding = {
  label: z.string().max(80).optional(),
  sourceId: z.uuid(),
  metricName: z.string().min(1).max(200),
  /** {} = every series of the metric. */
  tags: z.record(z.string(), z.string()).default({}),
};

export const rangeSchema = z.enum(TIME_RANGES);
export const aggSchema = z.enum(METRIC_AGGREGATES);
export const unitSchema = z.string().max(8).optional();
export const decimalsSchema = z.number().int().min(0).max(4).default(0);
